<div class="modal-body">
  <div class="icon-circle">
    <img src="assets/icons/Info-icon.svg" alt="close">
  </div>
  <h3 class="title">Activate Document</h3>
  <p class="desc">
    You're about to activate document version of <strong>{{ collectionName }}</strong>
    <strong>{{ documentName }}</strong>. Once activated, the chatbot will start using this
    version for all knowledge queries.
  </p>
  <div class="actions">
    <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="onActivate()">Activate</button>
  </div>
  
</div>

